export default __webpack_public_path__ + "static/media/191.de364bd3.png";